export default __webpack_public_path__ + "static/media/error2.9cdd5783.svg";